import { BaseDrawerProps } from "./Base.drawer"
import PanelButton from "../PanelButton"
import { cn } from "@/lib/utils"
import { ScenarioNodeData } from "@/stores/scenario.store"
import { store } from "@/stores/stores"
import { Separator } from "@/components/ui/separator"

interface BaseActionProps extends BaseDrawerProps {
  children?: React.ReactNode
  title?: React.ReactNode
  onClose?: () => void
  contentClassName?: string
  // action?: ScenarioNodeData
}

function BaseAction(props: BaseActionProps) {
  // const actionDef = store.scenario.nodeDefinitions.record[props.action?.node_type!]

  return (
    <div className="size-full flex flex-col">
      <div
        className={cn("sticky top-0 bg-background p-5 pt-4 pb-4", "rounded-t-2xl")}
        // style={{
        //   background: `linear-gradient(126deg, ${actionDef?.color} 0%, ${actionDef?.color} 100%)`,
        // }}
      >
        <header className="relative flex w-full text-lg font-semibold">
          {props.title}
          <PanelButton
            label={
              <div className="flex items-center">
                Close
                <kbd className="ml-2 rounded bg-white/20 px-1 text-[10px] font-semibold">ESC</kbd>
              </div>
            }
            onClick={props.onClose}
            tooltipDelay={300}
            className="absolute -top-1 -right-1"
            // className={`
            //   absolute -left-[68px] top-0.5 !size-8 bg-backgroundp-0 shadow-panel transition-transform duration-150

            //   hover:scale-110
            // `}
          >
            <IconIconamoonSignTimesFill className="size-5" />
          </PanelButton>
          {/* <ActionIcon color="dark" variant={"subtle"} size={"lg"} type="button" onClick={props.onClose} className="absolute -top-0 right-0">
            <IconIconamoonSignTimesFill className="size-6" />
          </ActionIcon> */}
        </header>
      </div>
      <div className={cn("p-5 pt-0 h-full flex-1 overflow-y-auto", props.contentClassName)}>
        {props.children}
        <br />
        <br />
      </div>
    </div>
  )
}

export default BaseAction
